import React from "react";
import { Rate } from "rsuite";

export default function StarRatingAnswer({ answer, answeres }) {
  return (
    <div className="answerWhite answerArea text-black bg-white rounded-br-none shadow rounded-2xl">
      <Rate
        value={parseFloat(
          answer?.question?.options?.find(
            (opt) => opt?._id === answeres[answer?.question?._id]?.value
          )?.text || 0
        )}
        allowHalf
        max={
          answer?.question?.options.length > 0
            ? Math.max(
                ...answer?.question?.options.map((option) => option.value)
              )
            : 5
        }
        size="sm"
        readOnly
      />
    </div>
  );
}
